<template>
  <div class="row pt-3 h-100">
    <div class="col col-12 mb-5">
      <InfoPanel v-if="isParticipant && needTeam && isCaptain">
        {{
          $t(
            '_web_tournament-participants-go-to-roster-text',
            'You can specify your team roaster to participate in tournament'
          )
        }}
        <template #addons>
          <Btn
            class="btn-accent-simple h-ml-auto"
            :label="
              $t(
                '_web_tournament-participants-go-to-roster-link',
                'Select roster'
              )
            "
            @click="goToRosterAction"
          />
        </template>
      </InfoPanel>
    </div>
    <div class="col col-12">
      <Subheader
        v-if="participants && participants.length"
        :text="
          $t('_web_tournament-participants-approved', 'Approved participants')
        "
      />

      <ListLoader
        :is-loading="isLoading && isEmpty"
        :is-empty-list="isEmpty"
        :dummy-props="{
          iconName: 'dummy/members',
          headerText: $t(
            '_web_tournament_no_participants_yet',
            'There are no participants yet'
          ),
        }"
        @reload="fetchUsers"
      >
        <Paginated
          slot="list"
          v-bind="{
            totalItems,
            hidePagination: !participants.length,
            pageSize,
            inContainer: true,
          }"
          class="mb-0 h-auto"
          @change="fetchUsers"
        >
          <div class="col">
            <div class="row">
              <div
                v-for="{
                  id,
                  fields_data: fieldsData,
                  type,
                  vanity_id: vanityId,
                } in participantsMapped"
                :key="`participant-${id}`"
                class="col-sm-12 col-lg-4 col-md-4 col-4 mb-5 participant-card"
              >
                <Panel>
                  <LinkAccount
                    v-bind="{ id, type, vanityId }"
                    :verified="
                      (fieldsData
                        ? fieldsData.approvedTo
                        : ''
                      ).toLowerCase() === 'verified'
                    "
                    class="d-flex justify-content-start align-items-center text-truncate text-light text-decoration-none font-size-sm"
                  >
                    <ListItem
                      v-if="fieldsData"
                      tag="span"
                      :avatar-props="
                        generateAvatarProps(fieldsData.avatar, type)
                      "
                      :title="fieldsData.username || id"
                      class="d-flex justify-content-start align-items-center"
                    >
                    </ListItem>
                  </LinkAccount>
                </Panel>
              </div>
            </div>
          </div>
        </Paginated>
      </ListLoader>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/atoms/Subheader';
import Panel from '@/components/atoms/Panel';
import ListLoader from '@/components/common/HeraListPreloader';
import ListItem from '@/components/common/ListItem';
import LinkAccount from '@/components/links/Account';
import Paginated from '@/components/common/Paginated';
import listMixin from '@/mixins/paginatedLists';
import isLoading from '@/mixins/isLoading';
import Btn from '@/components/atoms/HeraFormBtn';
import InfoPanel from '@/components/molecules/InfoPanel';
import { mapState, mapActions, mapMutations } from 'vuex';
import { PROFILE, CLAN } from '@/constants/accounts';

export default {
  name: 'TournamentParticipants',
  components: {
    Subheader,
    Panel,
    ListLoader,
    ListItem,
    LinkAccount,
    Paginated,
    Btn,
    InfoPanel,
  },
  mixins: [...listMixin, isLoading],
  data() {
    return {
      participants: [],
      mySquad: [],
    };
  },
  computed: {
    ...mapState('current', ['accountId', 'account']),
    ...mapState('my', { myLogin: 'accountId' }),
    participantsMapped() {
      return this.participants.map(el => {
        const type = el.members ? CLAN : PROFILE;
        return { ...el, type };
      });
    },
    isEmpty() {
      return !this.participants.length;
    },
    isParticipant() {
      return (
        this.account.participantStatus &&
        this.account.participantStatus !== 'revoked'
      );
    },
    isCaptain() {
      return (
        this.mySquad.findIndex(
          teammate => teammate.login === this.myLogin && teammate.captain
        ) > -1
      );
    },
    needTeam() {
      return this.account.squadSize > 1;
    },
  },
  created() {
    this.fetchUsers();
    if (this.isParticipant) {
      this.getTournamentSquadParticipants()
        .then(squad => {
          this.mySquad = squad || [];
        })
        .catch(this.errorNotify);
    }
  },
  methods: {
    ...mapActions([
      'getTournamentParticipants',
      'getTournamentSquadParticipants',
      'errorNotify',
    ]),
    ...mapMutations(['setRegistrationTournament']),
    fetchUsers(newPage) {
      this.pageIndex = newPage;
      if (this.account.isTournament) {
        this.getPageData(
          'participants',
          this.getTournamentParticipants({
            id: this.accountId,
            query: this.paramsWithPageNumber(),
          })
        )
          .catch(this.errorNotify)
          .finally(this.unsetLoading);
      }
    },

    generateAvatarProps(avatar, type) {
      return {
        size: 48,
        type,
        imgUrl: avatar,
      };
    },
    goToRosterAction() {
      this.setRegistrationTournament(this.account._data);
      this.$router.push({
        name: 'tournamentRegistrationCreateRoster',
        params: {
          ...this.$route.params,
          tournamentID: this.accountId,
        },
      });
    },
  },
};
</script>
